
import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, IntlShape} from 'react-intl';

import ChannelIcon from '../channel-defs/ChannelIcon.react';
import {maxTextLength} from '../fw/Tool';
import DetailToolBar from '../fw/DetailToolBar.react.js';
import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import * as Permission from "../../common/util/Permission";
import * as BrowserPermission from "../BrowserPermission";
import { Organisation } from '../../common/types/types';

interface ChannelHeaderProps {
 actions?: unknown[];
 actions2?: unknown[];
 children?: React.ReactNode;
 data?: object;
 hasCustomName?: boolean;
 isChannelDef?: boolean;
 organisation?: Organisation;
 tag?: any;
 title?: string;
}

export default class ChannelHeader extends React.Component<ChannelHeaderProps> {
    typeName = 'channels';

    static propTypes = {
        actions: PropTypes.array,
        actions2: PropTypes.array,
        children: PropTypes.node,
        data: PropTypes.object,
        hasCustomName: PropTypes.bool,
        isChannelDef: PropTypes.bool,
        organisation: PropTypes.object,
        tag: PropTypes.any,
        title: PropTypes.string,
    };

    getTitle(data) {
        let title = data.channelDef.name;
        if (data.name) {
            title += ' - ' + data.name;
        }

        return title;
    }

    render() {
        let {actions, actions2, data, title, tag, isChannelDef} = this.props;
        let type = types[this.typeName];

        let editButtonTitle;
        if (!isChannelDef) {
            editButtonTitle = (<FormattedMessage defaultMessage="Add custom name" id="application.addCustomName" />);
            if (data.name) {
                editButtonTitle = (<FormattedMessage defaultMessage="Edit custom name" id="application.editCustomName" />);
            }

            if (!title) {
                title = this.getTitle(data);
            }
        }

        return (
            <div className="flex-row ChannelHeader">
                <div className="flex flex-row">
                    <div className="flex-nogrow flex-column">
                        <span className="flex"></span>
                        <ChannelIcon channelDef={isChannelDef ? data : data.channelDef} className="channelViewMainIcon" size={128}/>
                        <span className="flex"></span>
                    </div>
                    <div className="flex flex-column">
                        <span className="flex"></span>
                        <h2> {maxTextLength(title)} {tag}</h2>
                        {this.props.children}
                        <span className="flex"></span>
                    </div>
                </div>
                {isChannelDef && BrowserPermission.hasOrganisationPermission(Permission.PERM_EDIT_CHANNEL, this.props.organisation ? this.props.organisation.realId : null) ? null :
                    <div className="flex-nogrow flex-column">
                        {(actions && actions.length) > 0 || (actions2 && actions2.length)
                            ? <DetailToolBar data={data} editButtonTitle={editButtonTitle} metadata={type} organisationId={this.props.organisation ? this.props.organisation.realId : null} urlMapping={urlMapping} vertical>
                                {this.props.actions}

                                {(actions && actions.length) > 0 || (actions2 && actions2.length) ? <div className="spacer" key="spacer1" /> : null}

                                {this.props.actions2}
                            </DetailToolBar>
                            : null
                        }
                    </div>
                }
            </div>
        );
    }
}
